<template>
    <el-dialog v-model="centerDialogVisible" title="Passwort ändern" width="300" center>
        <el-form
            :rules="rules"
            ref="passwordForm"
            :model="passworddata"
        >
            <el-form-item
                :rules="rules.password"
                prop="password"
            >
                <el-input type="password" v-model="passworddata.password" ref="password" placeholder="altest Passwort"
                          show-password/>
            </el-form-item>
            <el-form-item
                :rules="rules.new1"
                prop="new1"
            >
                <el-input type="password" v-model="passworddata.new1" ref="new1" placeholder="neues Passwort"
                          show-password/>
            </el-form-item>
            <el-form-item
                :rules="rules.new2"
                prop="new2"
            >
                <el-input type="password" v-model="passworddata.new2" ref="new2" placeholder="Passwort wiederholen"
                          show-password/>
            </el-form-item>
            <el-button type="primary" @click="change">Passwort ändern</el-button>
        </el-form>
    </el-dialog>
    <el-button text @click="centerDialogVisible = true">
        Passwort ändern
    </el-button>
</template>

<script>
import {reactive, ref} from "vue";
import Axios from "axios";
import {ElNotification} from 'element-plus'

export default {
    name: "password",
    data() {
        return {
            password: ref(''),
            new1: ref(''),
            new2: ref(''),
            rules: {
                password: [{required: true, trigger: ['blur']}],
                new1: [{required: true, message: 'darf nicht leer sein', trigger: ['blur']}],
                new2: [{required: true, message: 'darf nicht leer sein', trigger: ['blur']},
                    {validator: this.customValidate, trigger: 'blur'}
                ]
            },
            centerDialogVisible: ref(false),
            passworddata: reactive({
                password: null,
                new1: null,
                new2: null
            }),
        };
    },
    methods: {
        customValidate: function (rule, value, callback) {
            const new1 = this.$refs.new1.input.value;
            if (new1 !== value) {
                callback(new Error('Die Passwörter stimmen nicht überein'));
            }
            callback()
        },
        change: function () {
            const me = this;
            me.$refs.passwordForm.validate((valid) => {
                if (valid) {
                    console.log('submit!')
                    Axios.put(`${process.env.VUE_APP_API_URL}/api/changepw`, {
                        password: me.passworddata.password,
                        newpw1: me.passworddata.new1,
                        newpw2: me.passworddata.new2,
                        email: me.$store.state.email
                    })
                        .then(response => {
                            me.centerDialogVisible = false;
                            ElNotification({
                                title: 'Erfolg',
                                message: 'Dein Passwort wurde erfolgreich geändert. Logge dich nun neu ein',
                                type: 'success',
                            });
                            setTimeout(() => {
                                me.$store.dispatch('logout');
                                me.$router.push('/');
                            }, 1000);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped>
.cardpassword {
    width: 250px;
}
</style>
